module.exports = __webpack_public_path__ + "img/anatomy.4b4dbf41.svg";